import React from "react";
import { AuthUserContext, withAuthorization } from "../../Auth/Session";
import Plan from "./Plan"
import Metabase from "../Metabase";
import { validateMetaLanguage } from "../../../utils/validateMetaLanguage";

class PlanCurrent extends React.Component {
  constructor(props) {
    super(props);
  };

  render() {
    let dash_id_es = 907;
    let dash_id_pt = 934;
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          // <Plan isCurrent={true} />
          <Metabase dashboardId={validateMetaLanguage(dash_id_es, dash_id_pt)} />
        )}
      </AuthUserContext.Consumer>
    );
  };
}

const condition = authUser =>
  !!authUser;

export default withAuthorization(condition)(PlanCurrent);
